import { useContext } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createFolder } from '@widgets/Files/api/createFolder';
import { handleStatusError } from '@widgets/Files/helpers/handleStatusError';
import { ContextFiles } from '@widgets/Files/model/context';

export const useCreateFolder = () => {
    const queryClient = useQueryClient();
    const { currentFolderId } = useContext(ContextFiles);
    const { t } = useTranslation();
    return useMutation({
        mutationFn: createFolder,
        onSuccess: (data) => {
            handleStatusError(
                data?.response?.data,
                t('useFileUpload.return.swal.manyFiles.button')
            );
            if (data.status === 'success') {
                queryClient.invalidateQueries({ queryKey: ['files', currentFolderId] });
            }
        },
    });
};
